import React, { Component } from 'react';
import './index.scss';

class LogoSVGgray extends Component {
	render() {
		return (
			<svg className={"st0-svg " + this.props.color}  viewBox="0 0 58.7 48.9" version="1.1">      
				<path className="st0gray" d="M22.1,45.1c-1.3,0.3-2.6,0-3.5-0.9L5.5,31.5l0,0l-0.1-0.2C5.3,31.2,5.1,31.1,5,31c-0.8-0.5-1.3-1.5-1.3-2.4V6.8
	c0-1.6,1.3-2.9,3-2.9s3,1.3,3,2.9v4.9c0,1,0.8,1.8,1.9,1.8s1.9-0.8,1.9-1.8V6.8c0-3.6-3-6.6-6.8-6.6S0,3.2,0,6.8v21.8
	c0,2.1,1,4,2.7,5.2c0.1,0,0.1,0.1,0.1,0.2l13.1,12.8c1.4,1.3,3.3,2.1,5.2,2.1c0.7,0,1.4-0.1,2-0.3c1-0.3,1.6-1.3,1.3-2.3
	C24.1,45.4,23.1,44.9,22.1,45.1L22.1,45.1z"/>
				<path className="st0gray" d="M52.1,0c-3.6,0-6.6,2.9-6.6,6.5v3.6c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V6.5c0-1.6,1.3-2.9,2.9-2.9
	s2.9,1.3,2.9,2.9V28c0,0.9-0.5,1.8-1.3,2.3l-13.3,13c-1.3,1.3-3.6,1.3-4.9,0l-20-19.7l-0.2-0.1c0,0-0.9-0.7-0.9-1.8
	c-0.1-1.3,1-2.6,1.8-3.4c0.7-0.7,0.7-1.9,0-2.5c-0.7-0.7-1.9-0.7-2.6,0c-2,2-3,4.1-2.9,6.2c0.1,2.5,1.7,4,2.2,4.4l20,19.6
	c1.3,1.3,3.2,2,5.1,2s3.7-0.7,5.1-2L56,33.3c0,0,0.1-0.1,0.1-0.1c1.7-1.2,2.6-3.1,2.6-5.2V6.5C58.7,2.9,55.8,0,52.1,0z"/>
				<path className="st0gray" d="M23.1,11.6l5.4-5.4c0.6-0.6,1.3-0.9,2.1-0.9s1.5,0.3,2.1,0.9c1.2,1.2,1.2,3,0,4.2l-5.4,5.4
	c-1.2,1.2-3,1.2-4.2,0S22,12.7,23.1,11.6z M37.5,12.1c0.8,0,1.5,0.3,2.1,0.9c0.6,0.6,0.9,1.3,0.9,2.1s-0.3,1.5-0.9,2.1l-5.4,5.4
	c-1.2,1.2-3,1.2-4.2,0s-1.2-3,0-4.2l5.4-5.4C36,12.4,36.7,12.1,37.5,12.1L37.5,12.1z M44.3,19c0.8,0,1.5,0.3,2.1,0.9
	c1.2,1.2,1.2,3,0,4.2L41,29.4c-1.2,1.2-3,1.2-4.2,0c-1.2-1.2-1.2-3,0-4.2l5.4-5.4l0,0C42.8,19.2,43.6,18.9,44.3,19z M25.2,20.4
	c0,0,0.1,0,0.2,0c0,1.8,0.6,3.5,1.9,4.9c1.3,1.3,3,2,4.7,2c0,0,0.1,0,0.2,0c0,1.8,0.6,3.6,1.9,4.9c1.3,1.3,3,2,4.7,2s3.4-0.7,4.7-2
	l5.4-5.4c2.6-2.6,2.6-6.9,0-9.5c-1.3-1.3-3.1-2-4.9-1.9c0,0,0-0.1,0-0.2c0-1.8-0.7-3.5-2-4.7c-1.3-1.3-3.1-2-4.9-1.9
	c0-1.8-0.6-3.6-1.9-4.9c-2.6-2.6-6.9-2.6-9.5,0l-5.4,5.4c-2.6,2.6-2.6,6.9,0,9.5C21.8,19.7,23.5,20.4,25.2,20.4L25.2,20.4z"/>
			</svg>
		);
	}
}

export default LogoSVGgray;
